const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:1706';

// Helper function to handle API responses
const handleApiResponse = async (response) => {
    const responseText = await response.text();

    if (responseText.trim().startsWith('<!DOCTYPE') || responseText.trim().startsWith('<html')) {
        throw new Error('Server returned HTML instead of JSON. Service may be down or misconfigured.');
    }

    if (!responseText || responseText.trim() === '') {
        throw new Error('Server returned empty response');
    }

    let data;
    try {
        data = JSON.parse(responseText);
    } catch (parseError) {
        throw new Error(`Failed to parse JSON response: ${parseError.message}`);
    }

    if (!response.ok) {
        const errorMessage = data.message || data.error?.message || `HTTP error! status: ${response.status}`;
        // Preserve the error code if available
        const error = new Error(errorMessage);
        if (data.error?.code) {
            error.code = data.error.code;
        }
        throw error;
    }

    return data;
};

// Create a new order
export const createOrder = async (orderData) => {
    try {
        const url = `${API_URL}/orders`; // Assuming the route is mounted at /orders

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(orderData),
            credentials: 'include'
        });

        const data = await handleApiResponse(response);

        return {
            success: true,
            data: data.data || data
        };
    } catch (error) {
        console.error('Error creating order:', error);
        return {
            success: false,
            error: error.message,
            code: error.code
        };
    }
};
